<template>
	<div class="virtualDeviceRTValueBody">
		<elRadioTree slot="tree" :dataList='virtualDeviceList' @checkItem="$store.deviceStore.commit('setNowVirtualDevice',$event)"></elRadioTree>
		<div class="VirtualDeviceRTValueRigth" slot="body">
			<!--日期弹窗-->
		
		</div>

	</div>
</template>

<script type="text/javascript">

	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	export default {
		components: {
	
			elRadioTree
		},
		props: [],
		data() {
			return {
				nowApptypeGroups: [],
				dataObject: {},
				totalSize: 0,
				pageLen: 100,
				nowIndex: 0,
				options: {},
				from2name: {},
				nowTimetype: 'day',
				apptypeValue: ['全选'],
			}
		},
		created() {
      	
    },
		mounted() {
		
	

		},
		destroyed() {},
		computed: {
			virtualDeviceList() {
				var data = this.$store.unitStore.getters.getUnitTree
        console.log("data",data);
				return isempty(data) ? [] : [unitList(data)]
			},
		
			
		
	
	
	
	
		
		},
		watch: {
			
		},
		methods: {
			
		
			
			
		
		}
	}
</script>

<style scoped>
	.monreportRigth {
		width: 85%;
		height: 100%;
		overflow: hidden;
		padding-bottom: 20px;
	}
	
	.tableData {
		width: 100%;
	}
	
	.tableData tr:nth-child(1) td {
		text-align: center;
		border: .01rem solid;
		margin-top: .1rem;
	}
	.VirtualDeviceRTValue {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: white;
	}
	
	.VirtualDeviceRTValueRigth {
		width: 100%;
		height: 100%;
		/*overflow: hidden;*/
		padding-bottom: 55px;
		margin-top: 70px;
	}
	
	.virtualDeviceRTValueBody {
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
	}
</style>